import MxFileViewerFieldV2, {
  MxFileViewerFieldV2Props
} from "@rf-l1/form/MxFileViewerField";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";
type omit = "inputRef" | "invalid" | "name" | "value" | "onChange" | "onBlur";
export type MxFormFileViewerFieldV2Props = Omit<MxFileViewerFieldV2Props, omit>;

const MxFormFileViewerFieldV2 = (props: MxFormFileViewerFieldV2Props) => {
  const { onBlur, onChange, inputRef, name, value, invalid, disabled } =
    useMxFieldControllerContext();

  return (
    <MxFileViewerFieldV2
      {...props}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      name={name}
      invalid={invalid}
      inputRef={inputRef}
    />
  );
};

export default MxFormFileViewerFieldV2;
